import { User } from '../types/auth';
import { Stakeholder } from '../types/stakeholder';
import { Organization } from '../types/organization';

const isAdmin = (user?: User | null) => !!user && (user.role === 'admin' || user.role === 'super_admin');
const isTopOwner = (user?: User | null) => !!user && user.role === 'top_owner';
const isRegularUser = (user?: User | null) => !!user && user.role === 'user';

export function canUpdateStakeholder(user: User | null | undefined, s?: Pick<Stakeholder, 'createdBy'> | null): boolean {
  if (!user || !s) return false;
  if (isAdmin(user) || isTopOwner(user)) return true;
  return isRegularUser(user) && s.createdBy === user.id;
}

export function canDeleteStakeholder(user: User | null | undefined, s?: Pick<Stakeholder, 'createdBy' | 'status'> | null): boolean {
  if (!user || !s) return false;
  if (isAdmin(user)) return true;
  if (isTopOwner(user)) return s.status !== 'approved';
  return isRegularUser(user) && s.createdBy === user.id;
}

export function canUpdateOrganization(user: User | null | undefined, o?: Pick<Organization, 'createdBy'> | null): boolean {
  if (!user || !o) return false;
  if (isAdmin(user) || isTopOwner(user)) return true;
  return isRegularUser(user) && o.createdBy === user.id;
}

export function canDeleteOrganization(user: User | null | undefined, o?: Pick<Organization, 'createdBy' | 'status'> | null): boolean {
  if (!user || !o) return false;
  if (isAdmin(user)) return true;
  if (isTopOwner(user)) return o.status !== 'approved';
  return isRegularUser(user) && o.createdBy === user.id;
}

export function canMergeStakeholders(user: User | null | undefined): boolean {
  if (!user) return false;
  return isAdmin(user);
}

export function canMergeOrganizations(user: User | null | undefined): boolean {
  if (!user) return false;
  return isAdmin(user);
}

